import { formatNumber } from "../../../utils/formatNumber";

const GROUPS = [
  { name: "กระดาษ", multiplier: 5.6735, icon: "paper" },
  { name: "พลาสติก", multiplier: 1.031, icon: "plastic" },
  { name: "อะลูมิเนียม", multiplier: 9.127, icon: "aluminum" },
  { name: "เหล็ก", multiplier: 1.832, icon: "iron" },
  { name: "โลหะผสม", multiplier: 4.391, icon: "mixed" },
  { name: "แก้ว", multiplier: 0.276, icon: "glass" },
];

const CATEGORY_TO_GROUP = {
  กระดาษ: "กระดาษ",
  "กล่องนม/กล่องน้ำผลไม้": "กระดาษ",
  แก้ว: "แก้ว",
  ถุงวิบวับ: "พลาสติก",
  พลาสติก: "พลาสติก",
  "ขยะ RDF": "พลาสติก",
  เหล็ก: "เหล็ก",
};

const numberValue = (value) => Number(value ?? 0) || 0;

function getGroupName(item) {
  const category = item?.product?.category;
  const subCategory = item?.product?.subCategory;
  const categoryName = category?.name ?? category?.title ?? item?.category?.name ?? item?.category?.title ?? "";
  const subCategoryName = subCategory?.name ?? subCategory?.title ?? item?.subCategory?.name ?? item?.subCategory?.title ?? "";

  if (categoryName === "โลหะมีค่า") {
    return subCategoryName === "อะลูมิเนียม" ? "อะลูมิเนียม" : "โลหะผสม";
  }

  return CATEGORY_TO_GROUP[categoryName];
}

function iconSvg(type) {
  const shapes = {
    paper: '<path d="M18 3h30l14 14v44H18zM48 3v16h14" fill="none" stroke="#333" stroke-width="3"/><path d="M26 34h28M26 43h28M26 52h20" stroke="#333" stroke-width="2"/>',
    plastic: '<path d="M29 4h18M33 4v10l-8 10v35h26V24l-8-10V4" fill="none" stroke="#333" stroke-width="3"/><path d="M25 34h26M25 42h26" stroke="#333" stroke-width="2"/>',
    aluminum: '<path d="M24 11h28l4 9v35H20V20zM20 28h36M20 49h36" fill="none" stroke="#333" stroke-width="3"/>',
    iron: '<path d="M12 24h52v12H12zM20 36v22h36V36M28 58h20" fill="none" stroke="#333" stroke-width="3"/>',
    mixed: '<circle cx="22" cy="43" r="10" fill="none" stroke="#333" stroke-width="3"/><path d="M30 24h30v28H30zM34 24l20-10 8 10" fill="none" stroke="#333" stroke-width="3"/>',
    glass: '<path d="M29 4h18v10l6 8v35c0 5-4 8-15 8s-15-3-15-8V22l6-8z" fill="none" stroke="#333" stroke-width="3"/><path d="M23 48h30" stroke="#333" stroke-width="2"/>',
  };
  return `<svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">${shapes[type]}</svg>`;
}

export function buildCarbonSummary(transaction) {
  if (Number(transaction?.shopId) !== 315) return null;

  const groups = GROUPS.map((group) => ({ ...group, weight: 0 }));
  for (const item of transaction?.items || []) {
    const groupName = getGroupName(item);
    const group = groups.find((entry) => entry.name === groupName);
    if (group) group.weight += numberValue(item?.netWeight ?? item?.weight);
  }

  const totalScore = groups.reduce(
    (sum, group) => sum + group.weight * group.multiplier,
    0,
  );
  const treesSaved = Math.floor(totalScore / 15);

  return {
    unbreakable: true,
    margin: [0, 0, 0, 0],
    table: {
      widths: ["*"],
      body: [[{
        stack: [
          {
            columns: groups.map((group) => ({
              width: "*",
              stack: [
                { svg: iconSvg(group.icon), width: 34, height: 34, alignment: "center" },
                { text: `${group.name} ${formatNumber(group.weight)} กิโลกรัม`, alignment: "center", fontSize: 9, bold: true },
                { text: `${formatNumber(group.weight * group.multiplier)} kgCO2eq`, alignment: "center", fontSize: 9 },
              ],
            })),
            columnGap: 3,
          },
          {
            text: [
              "บิลนี้ลดคาร์บอนได้รวมทั้งหมด ",
              { text: formatNumber(totalScore), bold: true },
              " kgCO2eq เทียบเท่าการปลูกต้นไม้ ",
              { text: String(treesSaved), bold: true },
              " ต้น (ภายใน 1 ปี)",
            ],
            alignment: "center",
            fontSize: 15,
            margin: [0, 12, 0, 0],
          },
        ],
        margin: [10, 12, 10, 12],
      }]],
    },
    layout: {
      fillColor: () => "#EFFFF0",
      hLineWidth: () => 0,
      vLineWidth: () => 0,
      paddingLeft: () => 0,
      paddingRight: () => 0,
      paddingTop: () => 0,
      paddingBottom: () => 0,
    },
  };
}
